import React from 'react';
import ReactDOM from 'react-dom';
import RecommendationAdapter from './RecommendationAdapter';
import ReblastDetailsAdapter from './ReblastDetailsAdapter';
import ReblastNotificationToggle from './ReblastNotificationToggle';
import UserTask from '../Common/Tasks/Container';
import ZillowWidget from '../Common/ZillowWidget';
import { MessageProvider } from '../Common/Message';

ReactDOM.render(
	<React.StrictMode>
		<MessageProvider>
			<RecommendationAdapter />
		</MessageProvider>
	</React.StrictMode>,
	document.querySelector('#RecommendationComponent')
);

if (RESAAS.Environment.ToggleView && window.reblastDetails) {
	ReactDOM.render(
		<React.StrictMode>
			<MessageProvider>
				<ReblastNotificationToggle />
			</MessageProvider>
		</React.StrictMode>,
		document.querySelector('#ReblastNotificationToggleComponent')
	);
}
if (window.reblastDetails) {
	ReactDOM.render(
		<React.StrictMode>
			<MessageProvider>
				<ReblastDetailsAdapter />
			</MessageProvider>
		</React.StrictMode>,
		document.querySelector('#ReblastDetailsComponent')
	);
}

ReactDOM.render(
    <React.StrictMode>
        <ZillowWidget />
		<UserTask />
	</React.StrictMode>,
	document.querySelector('#SideWidget')
);



